<template>
  <v-card dark color="black" tile height="100%">
    <v-container style="height:100vh" class="pa-0">
      <v-row justify="center" align="center" class="fill-height pa-0">
        <v-col class="col-auto pa-0">
          <div
            class="font-weight-light white--text d-flex flex-column align-center justify-center"
          >
            <img
              alt="MetaPolis"
              src="../assets/metapolis-logox1-inverted.png"
              class="mt-1 mb-6"
              style="width:160px"
            />
            <span class="headline mb-4">PAGE NOT FOUND</span>
            <!--<span class="light-blue&#45;&#45;text"
              >No worries getting you a random image in {{ countDown }}</span
            >-->
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "NotFound",
  data() {
    return {
      countDown: 5,
      randomImageId: null,
      timeout: null
    };
  },
  watch: {
    countDown(val) {
      if (val === 0) {
        this.$router.push("/images/" + this.randomImageId);
      }
    }
  },
  mounted() {
    this.randomImageId = this.$store.getters.randomId;
    // this.countDownTimer();
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
  methods: {
    countDownTimer() {
      if (this.countDown > 0) {
        this.timeout = setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    }
  }
};
</script>

<style scoped></style>
